import isEmpty from "lodash-es/isEmpty";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { UserProfileState } from "@/types/userProfile";
import type { AuthUserData } from "@/types/authMeResponse";

const initialState: UserProfileState = {
  organisation: undefined,
  currentFinancialInstitution: undefined,
  groups: [],
};

const userProfileSlice = createSlice({
  name: "userProfile",
  initialState,
  reducers: {
    updateOrganisation(state, action: PayloadAction<string>) {
      state.organisation = action.payload;
    },
    updateCurrentFinancialInstitution(state, action: PayloadAction<string>) {
      state.currentFinancialInstitution = action.payload;
    },

    syncUserProfileFromServer(state, action: PayloadAction<AuthUserData>) {
      const { identity } = action.payload;
      const orgRaw = identity.organisation;
      const org =
        typeof orgRaw === "string" && orgRaw.trim() !== "" ? orgRaw.trim() : "";
      const previousCurrentFi = state.currentFinancialInstitution;
      const groups = Array.isArray(identity.groups)
        ? identity.groups.filter((g): g is string => typeof g === "string")
        : [];

      Object.assign(state, { ...initialState, groups: [] as string[] });
      state.currentFinancialInstitution = previousCurrentFi;
      state.groups = groups;
      if (!isEmpty(org)) {
        state.organisation = org;
        if (isEmpty(state.currentFinancialInstitution)) {
          state.currentFinancialInstitution = org;
        }
      }
    },
  },
});

export const {
  updateOrganisation,
  updateCurrentFinancialInstitution,
  syncUserProfileFromServer,
} = userProfileSlice.actions;
export default userProfileSlice.reducer;
